var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-aside',[_c('MyAside',{ref:"aside",attrs:{"width":"200px"},on:{"plugin-selected":_vm.handlePluginSelected}})],1),_c('el-container',[_c('el-header',[_c('MyHeader')],1),_c('el-main',[_c('MyMain',{ref:"main",attrs:{"selected-plugin":_vm.selectedPlugin}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }